import * as angular from 'angular';
/**
 * @ngInject
 */
export class ModalBackdropFactory {
    constructor($document, $compile, $rootScope, $q) {
        this._isVisible = false;
        this._isAnimated = false;
        this._openModals = 0;
        this._doHide = () => {
            this._isVisible = false;
            this._bodyElement.removeClass('modal-open');
        };
        this.$q = $q;
        this._bodyElement = $document.find('body');
        const backdropElement = angular.element('<bs-modal-backdrop ng-if="isVisible()"></bs-modal-backdrop>'), backdropScope = $rootScope.$new(true);
        // create backdrop element in body
        backdropScope.isVisible = this.isVisible.bind(this);
        $compile(backdropElement)(backdropScope);
        this._bodyElement.append(backdropElement);
    }
    isVisible() {
        return this._isVisible;
    }
    isAnimated() {
        return this._isAnimated;
    }
    show(backdrop, animate) {
        this._openModals++;
        this._backDropPromise = this.$q.defer();
        this._isAnimated = !!animate;
        this._bodyElement.addClass('modal-open');
        if (backdrop && !this._isVisible) {
            this._isVisible = true;
        }
        else {
            this._backDropPromise.resolve();
        }
        return this._backDropPromise.promise;
    }
    shown() {
        this._backDropPromise.resolve();
    }
    hide() {
        this._openModals--;
        if (this._openModals < 0) {
            this._openModals = 0;
        }
        if (this._openModals === 0) {
            if (angular.isDefined(this.backdropController)) {
                this.backdropController.hide().then(this._doHide);
            }
            else {
                this._doHide();
            }
        }
    }
}
